<template>
    <div class="information">
        <div class="information_card" :class="{'ac-bg-gray': ac}">
            <div class="information_close">
                <button :class="{'information_btn_close-ac': ac, 'information_btn_close': !ac}" @click.prevent="$emit('close')"></button>
            </div>
            <section class="information_img">
                <img src="../assets/images/info.png" />
            </section>
            <p class="information_message" v-html="message" :class="{'ac-color-white': ac}"></p>
            <div class="information_container_button">
                <button class="information_btn_close_button" :class="{'ac-bg-yellow': ac, 'ac-color-black': ac}" @click.prevent="closeInformation">Fechar</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import trackEvent from "../services/trackEvent";

    export default {
        name: "InfomationComponent",
        props: {
            success: {
                default: false
            },
            danger: {
                default: false
            },
            warning: {
                default: false
            },
            description: {
                default: "Sucesso"
            },
            message: {
                default: ""
            }
        },
        data() {
            return {

            }
        },
        computed: mapState({
            ac: state => state.ac,
            customer: state => state.customer,
        }),
        methods: {
            closeInformation() {
                trackEvent.track({
                    'user': {
                        'login': this.customer.login,
                        'loginType':  '',
                        'lineType':  this.customer.loginType,
                        'segment': this.customer.segment,
                        'subSegment':  this.customer.subSegment,
                        'planCode': this.customer.planCode,
                        'planName':  this.customer.planName
                    },
                    'channel': trackEvent.getChannel(),
                    'event-category': 6,
                    'event-label': 'Troca de Chip Informacao Embalagem',
                    'event-value': null,
                    'event-status': 'Sucesso',
                    'event-interactionNumber': ''
                });
                this.$emit('close');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .information {
        width: 100%;
        height: 100vh;
        display: flex;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10000;
        background: rgba(0,0,0,0.6);
        overflow-y: auto;
        > .information_card {
            width: 335px;
            min-height: 526px;
            position: relative;
            display: block;
            margin: 0 auto;
            border-radius: 16px;
            box-shadow: 0 24px 50px 0 rgba(0, 0, 0, 0.2);
            background: #ffffff;
            > .information_close {
                width: 100%;
                height: 17px;
                margin: 25px auto;
                display: block;
                position: relative;
                z-index: 2;
                > .information_btn_close {
                    width: 17px;
                    height: 17px;
                    float: right;
                    display: block;
                    position: relative;
                    z-index: 3;
                    background: url("../assets/images/close.svg") no-repeat;
                    border: 0;
                    margin-right: 25px;
                }
                > .information_btn_close-ac {
                    width: 17px;
                    height: 17px;
                    float: right;
                    display: block;
                    position: relative;
                    z-index: 3;
                    background: url("../assets/images/close-ac.png") no-repeat !important;
                    border: 0;
                    margin-right: 25px;
                }
            }
            > .information_img {
                width: 300px;
                height: auto;
                display: block;
                position: relative;
                margin: 40px auto;
                > img {
                    width: 100%;
                    height: auto;
                    position: relative;
                    display: block;
                    border-radius: 15px;
                    -webkit-border-radius: 15px;
                }
            }
            > .information_description {
                width: 258px;
                height: 120px;
                margin: 37px auto 0 auto;
                font-family: 'timsans_thin';
                font-size: 2em;
                font-weight: 600;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #000000;
            }
            > .information_message {
                width: 240px;
                height: 72px;
                display: block;
                margin: 24px auto 0 auto;
                font-family: 'timsans_regular';
                font-size: 1em;
                line-height: 1.5;
                letter-spacing: -0.2px;
                text-align: center;
                color: #666666;
            }
            > .information_container_button {
                width: 100%;
                height: auto;
                display: block;
                position: relative;
                margin-top: 40px;
                > .information_btn_close_button {
                    width: 286px;
                    min-height: 52px;
                    margin: 0 auto;
                    padding: 16px 0;
                    position: relative;
                    display: grid;
                    border-radius: 26px;
                    box-sizing: border-box;
                    background-color: #003091;
                    color: #ffffff;
                    border: none;
                    font-family: 'timsans_regular';
                    font-size: 1em;
                    text-align: center;
                }
            }
        }
    }
    @media (min-width: 768px) {
        .information {
            > .information_card {
                width: 482px;
                min-height: 526px;
                position: relative;
                display: block;
                margin: 0 auto;
                border-radius: 16px;
                box-shadow: 0 24px 50px 0 rgba(0, 0, 0, 0.2);
                background: #ffffff;
                > .information_img {
                    width: 300px;
                    height: auto;
                    display: block;
                    position: relative;
                    margin: 40px auto 32px auto;
                }
                > .information_message {
                    width: 240px;
                    height: auto;
                    margin: 24px auto 0 auto;
                }
                > .information_container_button {
                    width: 100%;
                    height: auto;
                    display: block;
                    position: relative;
                    margin-top: 31px;
                    > .information_btn_close_button {
                        width: 191px;
                        min-height: 52px;
                        margin: 0 auto;
                        padding: 16px 0;
                        position: relative;
                        display: grid;
                        border-radius: 26px;
                        box-sizing: border-box;
                        background-color: #003091;
                        color: #ffffff;
                        border: none;
                        font-family: 'timsans_regular';
                        font-size: 1em;
                        text-align: center;
                    }
                }
            }
        }
    }
</style>
